

// Because of decentrilized HR resposibilities across the EON Companies, things like logos, colors, texts for certain fields 
// changes from Comp to Comp. To adress these needs, every company can have its own 'branding' of the OCA.
// After Vue loaded and called successfully against SFData for ReqData, it filters on the 'filter2' SF-Field in order to load the
// Company-specific configuration for this job requisition.
// This function returns 1 companyConfiguration

export default function getCompanySpecificConfig(insertedCompanyId) {

    let data = [

        //EON STANDARD; has to be on top ---
        {
          companyIds: ["postingCompany_EON Business Solutions Deutschland","postingCompany_Netz_GmbH", "postingCompany_EON_SE", "postingCompany_EON_GmbH~%23", "postingCompany_EON_GmbH~%22", "postingCompany_Charge_GmbH", "postingCompany_Energie_Management", "postingCompany_E_GmbH~%1", "postingCompany_PreussenElektra_GmbH",  "postingCompany_EON_Metering", "postingCompany_EON_Dialog", "postingCompany_EON_Contracting", "postingCompany_EON_Consulting~%1", "postingCompany_EON_Technology", "postingCompany_EON_Projects", "postingCompany_EON_Solutions~%1", "postingCompany_EON_Solutions", "postingCompany_EON_Mobil", "postingCompany_EON_Deutschland~%1", "postingCompany_EON_Service", "postingCompany_EON_Bioerdgas", "postingCompany_EON_Regensburg", "postingCompany_E.ON impulse GmbH", "postingCompany_GroupInnovation_GmbH~%1", "postingCompany_E.ON Gastronomie GmbH", "postingCompany_EON_GmbH~%24", "postingCompany_E.ON Foundation gGmbH", "postingCompany_innogy chargetech", "postingCompany_E.ON Energy Projects GmbH", "postingCompany_E.ON Portfolio Solutions GmbH", "postingCompany_Kraftwerk Plattling", "postingCompany_Green Steam_GmbH", "postingCompany_Drive_Infrastructure_GmbH", "postingCompany_EON_GmbH~%25", "postingCompany_EON_BVBA", "postingCompany_EON_EPPB", "postingCompany_E.ON Hydrogen GmbH", "postingCompany_E.ON_Drive", "postingCompany_OttoGeiler_GmbH", "postingCompany_E.ON_Drive_Austria_GmbH","postingCompany_E.ON_Drive_France","postingCompany_E.ON_Drive_Spain","postingCompany_E.ON_Drive_Switzerland_GmbH","postingCompany_E.ON_Drive_Germany","postingCompany_Evailable","postingCompany_E.ON_Solar Solutions GmbH"],
          ocaId: "eonStandard", //fuersMappingDerPrivacyTexte
          //Chose: "company", "contractType", "workTime", "locations"
          //Will be applied in the given order
          subheaderConfig: ["company", "contractType", "workTime"],
          header: false,
          footer: true,
          disabilityText: {
            de_DE: 'Die Integration von Menschen mit Behinderung entspricht unserem Selbstverständnis und wir begrüßen daher deren Bewerbung. Wir wären demzufolge dankbar zu erfahren, ob eine Schwerbehinderung gem. § 2 Abs.2 SGB IX vorliegt oder eine Gleichstellung gem. § 2 Abs.3 SGB IX festgestellt wurde. Wir weisen darauf hin, dass die Beantwortung dieser Frage freiwillig ist und im Falle einer bestehenden Schwerbehinderung/Gleichstellung nicht bzw. nicht wahrheitsgemäß beantwortet werden muss.',
            en_GB: 'The integration of people with disabilities corresponds to our self-image and we welcome all applications. We would therefore be grateful to know whether a severe disability according to § 2 para. 2 SGB IX exists. We point out that answering this question is voluntary and does not have to be answered truthfully in the case of an existing severe disability.',
            en_US: 'The integration of people with disabilities corresponds to our self-image and we welcome all applications. We would therefore be grateful to know whether a severe disability according to § 2 para. 2 SGB IX exists. We point out that answering this question is voluntary and does not have to be answered truthfully in the case of an existing severe disability.'
          },
          logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
          jobLayout: [
            {
              id: "recJobLayout_E.ON HQ_00",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/158cd14a-d979-4177-af0e-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_01",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/0a7f5cd5-52ed-4c23-97a4-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_02",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/7cac3975-dc5c-4a17-9543-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_03",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/75aa9489-4bc4-49c1-aa47-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_04",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/0e77a367-5884-4720-991c-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_05",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/9194ec07-fc83-4ac5-9617-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_06",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/782851fb-5c8a-4407-8d97-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_07",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/f3bfbe92-ad67-4319-bb3d-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_08",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/f629f11e-956d-4188-a470-c.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_09",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d5605bb2-b7e4-4fb7-8f9e-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_10",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/2eb14c8f-1be1-4fd8-a71c-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_11",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/c7fe6654-c029-4642-94da-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_12",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/4a8f0603-5fbd-41e6-b8ef-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_13",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/0c0f15fa-f41c-46b2-9781-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_14",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/e765c713-b794-47d2-96f1-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_15",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/499f928f-0887-4e3e-8f1e-9.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_16",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/a5d75b0f-1785-4f31-a621-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_17",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/30304b69-243a-443e-b570-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_18",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/64f8f7ba-301b-4de5-8b42-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_19",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/3fec8b67-b4e2-465f-9162-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_20",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/34d03ed6-8c67-4b4e-9321-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_21",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/2efaa428-27ff-4696-8bf5-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_22",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/026680f6-74db-4e7b-b23f-c.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_23",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/866a80f2-448d-4be3-b107-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_24",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/4fe16aec-a002-4677-9cac-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_25",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/064e3070-c3ce-4775-be1c-7.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_27",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/69ac781f-6c2c-48b2-baeb-0.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_28",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/ab07d36e-4b00-4892-bdbd-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_29",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/f9d96d0a-343b-4f4d-bf3c-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_30",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/162cfa52-370d-45ae-978b-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_31",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/89579af5-48f0-49c1-9a2b-c.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_32",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/2742a295-d3ca-48df-8498-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_33",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/0f70c6da-25df-46f8-b54d-c.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_34",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/f9277a7f-2c41-45d6-96fd-0.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_35",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/70dc570f-70ee-49fe-aaa1-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_36",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d4c49858-2ec9-4ac5-a304-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_37",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/25a693de-42d6-45ac-98b3-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_38",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/6541123c-af8d-4975-a89f-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_39",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/0569c668-9c53-4360-98c4-7.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_40",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/e4c37eb2-2da4-4f95-b4ef-9.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_41",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/6a2b3d4c-889e-4664-95cf-7.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_42",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/e1812c81-0d10-4584-a631-7.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_43",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/ad25d12b-e0ec-4753-894f-7.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_44",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/0bc309a3-299b-43f5-865e-7.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_45",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/8c4021d4-fc53-4651-ae2b-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_46",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/8c4021d4-fc53-4651-ae2b-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_47",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/14895794-34fc-49a6-b541-6.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_48",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/8c4021d4-fc53-4651-ae2b-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_49",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/bfda315e-2efa-4805-8cc2-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_50",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/eefc3444-1a7c-4391-89be-a.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_51",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/02a30676-2265-450c-9d17-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_52",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/92b2a598-5a4d-45d0-bf70-6.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_53",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d1ce47b2-147e-49fe-aafb-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_54",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/e9f0be3a-4999-4e54-9540-a.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_55",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/c8b23106-2962-4b70-89d2-c.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_56",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/ac4ce0d9-cb24-4670-bfcc-f.png"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_57",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/0e079491-3df0-419f-bf46-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON_HQ_58",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/3dbbdb9d-c95f-4ce5-997c-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_01_OttoGeiler_STANDARD",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/b6e8f37a-21f6-4607-b482-a.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_02_OttoGeiler_TwoMan",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/4d274cc4-6615-4c34-9f0c-4.jpg"
                }
              ],
            }
          ],
          links: {
            link1: {
              de_DE: {
                desc: "Karriere bei E.ON",
                url: "https://www.eon.com/de/ueber-uns/karriere.html"
              },
              en_GB: {
                desc: "Karriere bei E.ON",
                url: "https://www.eon.com/de/ueber-uns/karriere.html"
              },
              en_US: {
                desc: "Karriere bei E.ON",
                url: "https://www.eon.com/de/ueber-uns/karriere.html"
              }
            },
            link2: {
              de_DE: {
                desc: "Über E.ON",
                url: "https://www.eon.com/de/ueber-uns.html"
              },
              en_GB: {
                desc: "Über E.ON",
                url: "https://www.eon.com/de/ueber-uns.html"
              },
              en_US: {
                desc: "Über E.ON",
                url: "https://www.eon.com/de/ueber-uns.html"
              }
            },
            link3: {
              de_DE: {
                desc: "Zurück zum Stellenmarkt",
                url: "https://jobs.eon.com/"
              },
              en_GB: {
                desc: "Zurück zum Stellenmarkt",
                url: "https://jobs.eon.com/"
              },
              en_US: {
                desc: "Zurück zum Stellenmarkt",
                url: "https://jobs.eon.com/"
              }
            },
            link4: {
              de_DE: {
                desc: "Benefits",
                url: "https://www.eon.com/de/ueber-uns/karriere/arbeitswelt.html"
              },
              en_GB: {
                desc: "Benefits",
                url: "https://www.eon.com/de/ueber-uns/karriere/arbeitswelt.html"
              },
              en_US: {
                desc: "Benefits",
                url: "https://www.eon.com/de/ueber-uns/karriere/arbeitswelt.html"
              }
            },
          },
            thankYouTexts: {
              de_DE: '<p>Vielen Dank f&uuml;r deine Bewerbung!</p><p><span style="color: #961482;"><strong>Become a playmaker in the energy transition</strong></span></p><p>Wir werden deine Bewerbung pr&uuml;fen und uns so schnell wie m&ouml;glich bei dir melden. In der Zwischenzeit kannst du dir auf unserer <a href="https://www.eon.de/de/pk.html">Seite</a> weitere Informationen &uuml;ber E.ON ansehen.</p><p><span style="color: #961482;"><strong>#eoncareer #myenergyeon</strong></span></p>',          
              en_GB: '<p>Thank you for your application!</p><p><span style="color: #961482;"><strong>Become a playmaker in the energy transition</strong></span></p><p>We will review your application and get back to you as soon as possible. In the meantime, you can take a look at our page for further information about E.ON.</p><p><span style="color: #961482;"><strong>#eoncareer #myenergyeon</strong></span></p>',
              en_US: '<p>Thank you for your application!</p><p><span style="color: #961482;"><strong>Become a playmaker in the energy transition</strong></span></p><p>We will review your application and get back to you as soon as possible. In the meantime, you can take a look at our page for further information about E.ON.</p><p><span style="color: #961482;"><strong>#eoncareer #myenergyeon</strong></span></p>'
           
            }
        },
        //Aschaffenburg
        {
          companyIds: ["postingCompany_Aschaffenburg"],
          ocaId: "eonStandard", //fuersMappingDerPrivacyTexte
          //Chose: "company", "contractType", "workTime", "locations"
          //Will be applied in the given order
          subheaderConfig: ["company", "contractType", "workTime"],
          header: true,
          footer: true,
          disabilityText: {
            de_DE: 'Die Integration von Menschen mit Behinderung entspricht unserem Selbstverständnis und wir begrüßen daher deren Bewerbung.',
            en_GB: 'E.ON is committed to equal opportunities and actively promotes diversity, equality and flexibility.',
            en_US: 'E.ON is committed to equal opportunities and actively promotes diversity, equality and flexibility.'
          },
          logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
          jobLayout: [
            {
              id: "recJobLayout_E.ON HQ_00",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/f78edc3c-89c5-4837-bfd3-f.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_01",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_02",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/63130ed1-cf67-4001-9eb0-f.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_03",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/572c2958-1610-48b3-8d6c-9.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_04",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/da1252d3-ebab-400d-9f94-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_05",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/402442f8-d64a-4921-b9ff-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_06",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/50435e0d-43bd-4695-8c34-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_07",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d6f19bdf-f789-4cef-b67b-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_08",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/c2e6375c-69a4-417f-9d1e-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_09",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d5605bb2-b7e4-4fb7-8f9e-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_10",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/4cd0e736-b63d-459f-aa68-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_11",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/9e04063c-1874-4d71-9262-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_12",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/9662bc95-ecd7-474b-925a-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_13",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/647c1eb8-4ba6-4ecf-a15a-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_14",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/2c10ba17-bb01-43b6-a41a-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_15",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/a00ee229-edc8-443e-86e0-9.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E.ON HQ_16",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/c4e94719-7baa-4263-905b-c.jpg"
                }
              ],
            },
          ],
          links: {
            link1: {
              de_DE: {
                desc: "Karriere bei E.ON",
                url: "https://www.eon.com/de/ueber-uns/karriere.html"
              },
              en_GB: {
                desc: "Karriere bei E.ON",
                url: "https://www.eon.com/de/ueber-uns/karriere.html"
              },
              en_US: {
                desc: "Karriere bei E.ON",
                url: "https://www.eon.com/de/ueber-uns/karriere.html"
              }
            },
            link2: {
              de_DE: {
                desc: "Über E.ON",
                url: "https://www.eon.com/de/ueber-uns.html"
              },
              en_GB: {
                desc: "Über E.ON",
                url: "https://www.eon.com/de/ueber-uns.html"
              },
              en_US: {
                desc: "Über E.ON",
                url: "https://www.eon.com/de/ueber-uns.html"
              }
            },
            link3: {
              de_DE: {
                desc: "Zurück zum Stellenmarkt",
                url: "https://jobs.eon.com/"
              },
              en_GB: {
                desc: "Zurück zum Stellenmarkt",
                url: "https://jobs.eon.com/"
              },
              en_US: {
                desc: "Zurück zum Stellenmarkt",
                url: "https://jobs.eon.com/"
              }
            },
            link4: {
              de_DE: {
                desc: "Benefits",
                url: "https://www.eon.com/de/ueber-uns/karriere/arbeitswelt.html"
              },
              en_GB: {
                desc: "Benefits",
                url: "https://www.eon.com/de/ueber-uns/karriere/arbeitswelt.html"
              },
              en_US: {
                desc: "Benefits",
                url: "https://www.eon.com/de/ueber-uns/karriere/arbeitswelt.html"
              }
            },
          },
            thankYouTexts: {
              de_DE: '<p>Herzlich Willkommen und vielen Dank f&uuml;r die Bewerbung!</p><p>Wir werden die Bewerbung pr&uuml;fen und uns schnellstm&ouml;glich zur&uuml;ck melden. Da dies etwas Zeit in Anspruch nehmen kann, geben die unten beigef&uuml;gten Links in der Zwischenzeit schon einmal spannende Einblicke in die Arbeitswelt bei E.ON.</p><p>Vielen Dank f&uuml;r das Verst&auml;ndnis!</p><p>&nbsp;</p><p><span style="color: #33cccc;"><strong>#eoncareer #myenergyeon</strong></span></p></p><p><span style="color: #ff0000;"><strong>The WE has no limits and none of us is as strong as all of us</strong>.</span></p>',
              en_GB: '<p>Welcome and Thank you for your application!</p><p>&nbsp;</p><p><span style="color: #ff0000;"><strong>We are happy that you want to become part of the WE</strong></span></p><p>We will review your application and get back to you as soon as possible. In the meantime, you can take a look at our appended links for further information about working at E.ON.</p><p>Thank you for your patience and understanding.</p><p>&nbsp;</p><p><span style="color: #33cccc;"><strong>#eoncareer #myenergyeon</strong></span></p><p><span style="color: #ff0000;"><strong>The WE has no limits and none of us is as strong as all of us.</strong></span></p>',
              en_US: '<p>Welcome and Thank you for your application!</p><p>&nbsp;</p><p><span style="color: #ff0000;"><strong>We are happy that you want to become part of the WE</strong></span></p><p>We will review your application and get back to you as soon as possible. In the meantime, you can take a look at our appended links for further information about working at E.ON.</p><p>Thank you for your patience and understanding.</p><p>&nbsp;</p><p><span style="color: #33cccc;"><strong>#eoncareer #myenergyeon</strong></span></p><p><span style="color: #ff0000;"><strong>The WE has no limits and none of us is as strong as all of us.</strong></span></p>'
              
           
            }
        },

        //WESTNETZ
        //MINT = postingCompany_EONGesellschaften
        {
          companyIds: ["postingCompany_Westnetz GmbH", "postingCompany_OIE AG"],
          ocaId: "westnetz", //fuersMappingDerPrivacyTexte
          subheaderConfig: ["company", "contractType", "workTime","workModel"],
          header: true,
          footer: true,
          disabilityText: {
            de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
            en_GB: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
            en_US: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.'
          },
          logo: require("../assets/westnetz-logo.gif"),
          jobLayout: [
            {
              id: "recJobLayout_Westnetz_01",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d1cece28-14c3-40d5-bbf9-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_02",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/87e724be-2b9a-4540-aeb8-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_03",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d3cca822-7c36-426c-9064-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_04",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/5edd4062-e46e-4ce2-97cb-a.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_05",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/5eb4cdca-8664-4189-a1c4-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_06",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/dd5ca133-70c6-494b-8117-9.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_07",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/2d67b2e2-928a-401c-889e-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_08",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/5f570405-215e-4af5-a98d-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_09",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/1242e492-3150-4d36-9ad4-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_10",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/33413814-12ce-452f-a595-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_11",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/d0f59ded-ef65-4b51-a6ce-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_12",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/98560a47-b391-4e02-9a14-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_13",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/2ac5ba83-bf07-4902-af04-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_14",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/43c78391-71a0-44e6-9a79-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_15",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/dbd4ea55-4bc3-4046-a64a-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_16",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/1996b389-c841-449f-8c86-6.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_17",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/a91862a6-aa8b-4e37-b72a-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_18",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/b72f6b76-9cd4-4530-90bd-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_19",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/f36d9488-cadd-4091-ab21-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_20",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/6c23bd94-55f8-4d63-a3fd-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_21",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/8e94ef38-7b41-4040-91e1-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_22",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/64feb22a-3dcd-4ebf-aad4-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_23",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/2b186cc1-91ca-45ad-9d30-f.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_24",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/77b9e2c6-fe92-4b97-84c5-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_25",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/7aa16137-3ba0-455e-92d2-a.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_26",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/e34e96aa-c484-4bf2-802a-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_27",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/5c230cc5-d7c2-47fa-adfa-7.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_28",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/5e94fb01-77be-47ae-a31c-0.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_29",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/f5a9ee1f-7a5f-4069-96ea-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_30",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/3a2969c6-4f8c-4aab-82b4-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_31",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/40935a6f-5ab3-4bf5-a59e-4.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_32",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/b40dd82d-47c3-44d6-bb5b-6.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_33",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/403d0eb3-94f1-40cc-afe2-f.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_34",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/76850e95-9d75-45fc-bbff-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_35",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/9620b1e9-0b82-43be-b06b-e.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_36",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/04d2c0db-d1f9-4a37-84be-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_37",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/b40dd82d-47c3-44d6-bb5b-6.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_38",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/bef93b42-ec5c-479e-bc91-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_39",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/c86cfa7b-fff6-42ae-81ab-9.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_40",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/036f9df1-47fd-4ff8-8cfd-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_41",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/5b02a5fa-4743-44f1-a159-0.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_42",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/b886d62f-8fba-4206-8d75-a.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_43",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/ddfa2c34-e547-497d-820c-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_44",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/ff06c378-f32a-45ff-81cf-9.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Westnetz_45",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/b842ae17-a474-4acb-9c23-c.jpg"
                }
              ],
            }

          ],           
          links: {
            link1: {
              de_DE: {
                desc: "Karriere bei Westnetz",
                url: "https://www.westnetz.de/karriere"
              },
              en_GB: {
                desc: "Karriere bei Westnetz",
                url: "https://www.westnetz.de/karriere"
              },
              en_US: {
                desc: "Karriere bei Westnetz",
                url: "https://www.westnetz.de/karriere"
              }
            },
            link2: {
              de_DE: {
                desc: "Über Westnetz",
                url: "https://www.westnetz.de/de.html"
              },
              en_GB: {
                desc: "Über Westnetz",
                url: "https://www.westnetz.de/de.html"
              },
              en_US: {
                desc: "Über Westnetz",
                url: "https://www.westnetz.de/de.html"
              },
            },
          },
          thankYouTexts: {
            de_DE: '<p><strong>Herzlichen Dank f&uuml;r Deine Bewerbung</strong></p><p><br />Der erste Schritt ist getan und Deine Bewerbung wurde erfolgreich an uns &uuml;bermittelt. Wir bedanken uns bei Dir für Deine Bewerbung und Dein damit verbundenes Interesse.</p><p>Jetzt sind wir an der Reihe: Im n&auml;chsten Schritt werden wir Deine Unterlagen sorgf&auml;ltig prüfen und uns anschließend bei Dir zur&uuml;ckmelden. Dieser Prozess kann etwas Zeit in Anspruch nehmen.</p><p>Mache Dir bis dahin gern ein Bild von uns als attraktiver Arbeitgeber. &Uuml;ber unsere Weiterempfehlungen bei kununu. Oder folge uns in den sozialen Medien.</p><p>Falls in der Zwischenzeit Fragen aufkommen, z&ouml;gere nicht, uns zu kontaktieren. Die in der Ausschreibung genannte Ansprechperson steht Dir gerne zur Seite.</p>',
            en_GB: '<p><strong>Herzlichen Dank f&uuml;r Deine Bewerbung</strong></p><p><br />Der erste Schritt ist getan und Deine Bewerbung wurde erfolgreich an uns &uuml;bermittelt. Wir bedanken uns bei Dir für Deine Bewerbung und Dein damit verbundenes Interesse.</p><p>Jetzt sind wir an der Reihe: Im n&auml;chsten Schritt werden wir Deine Unterlagen sorgf&auml;ltig prüfen und uns anschließend bei Dir zur&uuml;ckmelden. Dieser Prozess kann etwas Zeit in Anspruch nehmen.</p><p>Mache Dir bis dahin gern ein Bild von uns als attraktiver Arbeitgeber. &Uuml;ber unsere Weiterempfehlungen bei kununu. Oder folge uns in den sozialen Medien.</p><p>Falls in der Zwischenzeit Fragen aufkommen, z&ouml;gere nicht, uns zu kontaktieren. Die in der Ausschreibung genannte Ansprechperson steht Dir gerne zur Seite.</p>',
            en_US: '<p><strong>Herzlichen Dank f&uuml;r Deine Bewerbung</strong></p><p><br />Der erste Schritt ist getan und Deine Bewerbung wurde erfolgreich an uns &uuml;bermittelt. Wir bedanken uns bei Dir für Deine Bewerbung und Dein damit verbundenes Interesse.</p><p>Jetzt sind wir an der Reihe: Im n&auml;chsten Schritt werden wir Deine Unterlagen sorgf&auml;ltig prüfen und uns anschließend bei Dir zur&uuml;ckmelden. Dieser Prozess kann etwas Zeit in Anspruch nehmen.</p><p>Mache Dir bis dahin gern ein Bild von uns als attraktiver Arbeitgeber. &Uuml;ber unsere Weiterempfehlungen bei kununu. Oder folge uns in den sozialen Medien.</p><p>Falls in der Zwischenzeit Fragen aufkommen, z&ouml;gere nicht, uns zu kontaktieren. Die in der Ausschreibung genannte Ansprechperson steht Dir gerne zur Seite.</p>'
          }
        },

        //EKN
        {
          companyIds: ["postingCompany_ekundenservice_GmbH"],
          ocaId: "ekn", //fuersMappingDerPrivacyTexte

          subheaderConfig: ["company", "contractType", "workTime", "locations"],
          header: true,
          footer: true,
          disabilityText: {
            de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Ihnen demzufolge dankbar, wenn Sie uns angeben würden, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Ihnen vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
            en_GB: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Ihnen demzufolge dankbar, wenn Sie uns angeben würden, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Ihnen vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
            en_US: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Ihnen demzufolge dankbar, wenn Sie uns angeben würden, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Ihnen vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.'
          },
          logo: "https://rmkcdn.successfactors.com/87ec45a4/c1000c33-6f5a-42b1-b263-2.png",
          jobLayout: [
            {
              id: "recJobLayout_Eknetz_00",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Eknetz_01",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/379a650f-68f5-4ec5-bff6-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Eknetz_02",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/afe03746-1073-47cc-8f2d-5.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Eknetz_03",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/c2e6375c-69a4-417f-9d1e-3.jpg"
                }
              ],
            },
          ],           
          links: {
            link1: {
              de_DE: {
                desc: "Karriere bei e.kundenservice Netz",
                url: "https://jobs.eon.com/eknetz/go/Alle-Stellen-bei-e_kundenservice-Netz/3728601/?utm_source=careersite"
              },
              en_GB: {
                desc: "Karriere bei e.kundenservice Netz",
                url: "https://jobs.eon.com/eknetz/go/Alle-Stellen-bei-e_kundenservice-Netz/3728601/?utm_source=careersite"
              },
              en_US: {
                desc: "Karriere bei e.kundenservice Netz",
                url: "https://jobs.eon.com/eknetz/go/Alle-Stellen-bei-e_kundenservice-Netz/3728601/?utm_source=careersite"
              }
            },
            link2: {
              
              de_DE: {
                desc: "Über e.kundenservice Netz",
                url: "https://www.eknetz.de/de.html"
              },
              en_GB: {
                desc: "Über e.kundenservice Netz",
                url: "https://www.eknetz.de/de.html"
              },
              en_US: {
                desc: "Über e.kundenservice Netz",
                url: "https://www.eknetz.de/de.html"
              }
            },
          },
          
          thankYouTexts: {
            de_DE: 'Herzlichen Dank für Deine Bewerbung Deine Unterlagen wurden erfolgreich übermittelt. Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen. Bilde Dir in der Zwischenzeit gerne Deine Meinung über uns als attraktiven Arbeitgeber. Wir empfehlen Dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren Unternehmensauftritten bei LinkedIn, Xing und Instagram. ',
            en_GB: 'Herzlichen Dank für Deine Bewerbung Deine Unterlagen wurden erfolgreich übermittelt. Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen. Bilde Dir in der Zwischenzeit gerne Deine Meinung über uns als attraktiven Arbeitgeber. Wir empfehlen Dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren Unternehmensauftritten bei LinkedIn, Xing und Instagram. ',
            en_US: 'Herzlichen Dank für Deine Bewerbung Deine Unterlagen wurden erfolgreich übermittelt. Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen. Bilde Dir in der Zwischenzeit gerne Deine Meinung über uns als attraktiven Arbeitgeber. Wir empfehlen Dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren Unternehmensauftritten bei LinkedIn, Xing und Instagram. '
          }
          
        },

        //Bayernwerk
        {
                  companyIds: ["postingCompany_Bayernwerk_AG~%1", "postingCompany_Bayernwerk_GmbH~%1", "postingCompany_Bayernwerk_GmbH", "postingCompany_Bayernwerk_AG"],
                  subheaderConfig: ["company", "contractType", "workTime", "locations"],
                  ocaId: "bayernwerk", //fuersMappingDerPrivacyTexte

                  header: true,
                  footer: true,
                  disabilityText: {
                    de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären dir demzufolge dankbar, wenn du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
                    en_GB: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.',
                    en_US: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.'
                  },
                  logo: "https://rmkcdn.successfactors.com/87ec45a4/4a6d1e49-efe2-41b5-9770-0.png",
                  jobLayout: [
                    {
                      id: "recJobLayout_Bayernwerk_00",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_01",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/bc88f94c-1817-4221-a579-b.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_02",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/898657ec-84e0-4235-9fe0-7.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_03",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/06260c13-d657-4593-9cbe-d.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_04",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/59f70b56-17c0-473d-8070-4.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_05",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/4c5ada7d-9727-44f3-ad54-f.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_06",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/96f04ee0-bd74-4c5f-b5d3-5.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_07",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/520f1f5f-ec69-4dfe-b312-3.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_08",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/2ba10613-a6bd-4a52-a5c9-4.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Bayernwerk_09",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/b7a7fe40-9038-4219-8b22-6.jpg"
                        }
                      ],
                    }
                  ],           
                  links: {
                    link1: {
                      de_DE: {
                        desc: "Karriere bei Bayernwerk",
                        url: "https://www.bayernwerk.de/de/karriere.html"
                      },
                      en_GB: {
                        desc: "Karriere bei Bayernwerk",
                        url: "https://www.bayernwerk.de/de/karriere.html"
                      },
                      en_US: {
                        desc: "Karriere bei Bayernwerk",
                        url: "https://www.bayernwerk.de/de/karriere.html"
                      }
                    },
                    link2: {
                      
                      de_DE: {
                        desc: "Über Bayernwerk",
                        url: "https://www.bayernwerk.de/de/ueber-uns.html"
                      },
                      en_GB: {
                        desc: "Über Bayernwerk",
                        url: "https://www.bayernwerk.de/de/ueber-uns.html"
                      },
                      en_US: {
                        desc: "Über Bayernwerk",
                        url: "https://www.bayernwerk.de/de/ueber-uns.html"
                      }
                    },
                  },
                  
                  thankYouTexts: {
                    de_DE: '<p><strong>Herzlichen Dank f&uuml;r deine Bewerbung.</strong></p><p><br />Deine Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilde dir in der Zwischenzeit gerne deine Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir empfehlen dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder auf unseren LinkedIn Unternehmensauftritt. Folge uns auch gerne &uuml;ber Facebook und verpasse kein Update des Bayernwerks.</p>',
                    en_GB: '<p><strong>Herzlichen Dank f&uuml;r deine Bewerbung.</strong></p><p><br />Deine Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilde dir in der Zwischenzeit gerne deine Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir empfehlen dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder auf unseren LinkedIn Unternehmensauftritt. Folge uns auch gerne &uuml;ber Facebook und verpasse kein Update des Bayernwerks.</p>',
                    en_US: '<p><strong>Herzlichen Dank f&uuml;r deine Bewerbung.</strong></p><p><br />Deine Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilde dir in der Zwischenzeit gerne deine Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir empfehlen dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder auf unseren LinkedIn Unternehmensauftritt. Folge uns auch gerne &uuml;ber Facebook und verpasse kein Update des Bayernwerks.</p>'
                  }
                  
        },

        //Westenergie
        {
                  companyIds: ["postingCompany_ESK GmbH", "postingCompany_innogy Westenergie GmbH", "postingCompany_Breitband GmbH", "postingCompany_innogy Metering GmbH", "postingCompany_Westenergie Netzservice GmbH", "postingCompany_Thielkasse"],
                  subheaderConfig: ["company", "contractType", "workTime", "locations"],
                  ocaId: "westenergie", //fuersMappingDerPrivacyTexte

                  header: true,
                  footer: true,
                  disabilityText: {
                    de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
                    en_GB: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
                    en_US: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.'
                  },
                  logo: "https://rmkcdn.successfactors.com/87ec45a4/cf76a478-1cfc-45f0-b2c4-2.png",
                  jobLayout: [


                    {
                      id: "recJobLayout_Westenergie_01",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/dcbb4c0d-8fd6-40ea-a8a4-5.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_02",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/31912efb-c435-4e19-a733-3.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_03",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/f33cf2d7-aebc-48c3-83cf-4.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_04",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/90552920-68e8-4930-981c-4.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_05",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/aa076b2b-e69c-4f39-a438-2.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_06",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/f2d89604-cc46-47ab-bd11-f.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_07",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/991468bc-f2f2-478e-ba71-2.jpg"
                        }
                      ],
                    },                    
                    {
                      id: "recJobLayout_Westenergie_08",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/1f889b23-8928-4a59-adf0-b.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_09",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/ff12585c-0433-4734-bc6c-6.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_10",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/4aae8bce-ca82-4eb0-8ec2-2.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_11",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/0f78b442-8aee-4934-a8b3-5.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_12",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/3004ba9f-f795-476b-919c-5.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_13",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/7f9336d7-4a49-4722-a3b8-3.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_14",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/de9e6897-fa48-4fca-9ec0-9.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_15",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/8460151b-6c2f-41ef-9871-d.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_16",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/16e381ff-cf46-4f48-b798-d.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_17",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/f5a91185-6aa6-49cb-968d-1.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_Westenergie_18",
                      pictureSize: 850,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/1c4af9a4-c1e8-40e6-b775-4.jpg"
                        }
                      ],
                    }

                  ],
                  links: {
                    link1: {
                      de_DE: {
                        desc: "Karriere bei Westenergie",
                        url: "https://www.westenergie.de/de/ueber-westenergie/karriere.html"
                      },
                      en_GB: {
                        desc: "Karriere bei Westenergie",
                        url: "https://www.westenergie.de/de/ueber-westenergie/karriere.html"
                      },
                      en_US: {
                        desc: "Karriere bei Westenergie",
                        url: "https://www.westenergie.de/de/ueber-westenergie/karriere.html"
                      }
                    },
                    link2: {
                      
                      de_DE: {
                        desc: "Über Westenergie",
                        url: "www.westenergie.de"
                      },
                      en_GB: {
                        desc: "Über Westenergie",
                        url: "www.westenergie.de"
                      },
                      en_US: {
                        desc: "Über Westenergie",
                        url: "www.westenergie.de"
                      }
                    },
                  },
                  
                  thankYouTexts: {
                    de_DE: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Ihre Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilden Sie sich in der Zwischenzeit gerne Ihre Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir &nbsp;empfehlen Ihnen einen Blick auf unseren LinkedIn Unternehmensauftritt zu werfen. Folgen Sie uns auch gerne &uuml;ber Facebook und Instagram und verpassen Sie kein Update der Westenergie.&nbsp;</p>',
                    en_GB: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Ihre Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilden Sie sich in der Zwischenzeit gerne Ihre Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir &nbsp;empfehlen Ihnen einen Blick auf unseren LinkedIn Unternehmensauftritt zu werfen. Folgen Sie uns auch gerne &uuml;ber Facebook und Instagram und verpassen Sie kein Update der Westenergie.&nbsp;</p>',
                    en_US: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Ihre Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilden Sie sich in der Zwischenzeit gerne Ihre Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir &nbsp;empfehlen Ihnen einen Blick auf unseren LinkedIn Unternehmensauftritt zu werfen. Folgen Sie uns auch gerne &uuml;ber Facebook und Instagram und verpassen Sie kein Update der Westenergie.&nbsp;</p>'
                  }
                  
        },

        //Hansewerk
        { 
            companyIds: ["postingCompany_HanseWerk_AG", "postingCompany_HanseWerk_GmbH", "postingCompany_Schleswig_AG", "postingCompany_Schleswig_GmbH", "postingCompany_HanseGas_GmbH"],
            subheaderConfig: ["company", "contractType", "workTime", "locations"],
            ocaId: "hansewerk", //fuersMappingDerPrivacyTexte

            header: true,
            footer: true,
            disabilityText: {
              de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
              en_GB: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.',
              en_US: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.'
            },
            logo: "https://rmkcdn.successfactors.com/87ec45a4/d1e47518-4859-405d-be4a-7.ico",
            jobLayout: [
              {
                id: "recJobLayout_Hansewerk_00",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_01",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/7dacfffb-6795-4a35-8d6f-4.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_02",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/20bd469e-562e-4b17-9bba-c.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_03",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/fd39d40b-1912-41fe-a927-e.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_04",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/6750c774-0d11-447c-9986-a.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_5",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/98fea3f0-f703-437d-9686-c.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_6",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/5138f89d-6eae-4b99-a5aa-c.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_7",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/01aa217d-7ef1-4855-9956-c.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_8",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/2dc05e21-d9da-444b-885a-5.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_9",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/054bda65-b28f-4bc5-b611-1.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_10",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/f15f47e4-e354-45e2-8175-e.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_Hansewerk_11",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/64c481f5-7f99-454a-bb5e-9.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_Hansewerk_12",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/d55f4a1e-3429-4210-878a-3.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_Hansewerk_13",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/49a63c84-0ce3-4a06-b480-1.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_Hansewerk_14",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/9aa26fe3-20df-4c39-b33c-1.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_Hansewerk_15",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/82b50220-d6a4-464d-8b19-c.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_Hansewerk_16",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/a48aedca-ac7a-4e3d-8d21-d.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_Hansewerk_17",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/bfbfb5cd-6930-4ee4-b5ee-3.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_Hansewerk_18",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/2b0d5077-cacf-4fa7-8b87-9.jpg"
                  }
                ]
              }
            ],           
            links: {
              link1: {
                de_DE: {
                  desc: "Karriere bei Hansewerk AG",
                  url: "https://www.hansewerk.com/de/karriere.html"
                },
                en_GB: {
                  desc: "Karriere bei Hansewerk AG",
                  url: "https://www.hansewerk.com/de/karriere.html"
                },
                en_US: {
                  desc: "Karriere bei Hansewerk AG",
                  url: "https://www.hansewerk.com/de/karriere.html"
                }
              },
              link2: {
                de_DE: {
                  desc: "Über Hansewerk AG",
                  url: "https://www.hansewerk.com/de/karriere/ueber-uns.html"
                },
                en_GB: {
                  desc: "Über Hansewerk AG",
                  url: "https://www.hansewerk.com/de/karriere/ueber-uns.html"
                },
                en_US: {
                  desc: "Über Hansewerk AG",
                  url: "https://www.hansewerk.com/de/karriere/ueber-uns.html"
                }
              },
            },
            
            thankYouTexts: {
              de_DE: '<p><strong>Vielen Dank f&uuml;r Ihre Bewerbung!</strong></p><p><br />Wir freuen uns, dass Sie Teil unseres Teams werden m&ouml;chten. Ihre Unterlagen werden nun von uns gepr&uuml;ft und wir melden uns zeitnah wieder bei Ihnen!</p><p><br />Viele Gr&uuml;&szlig;e<br />Ihr Recruiting-Team</p>',
              en_GB: '<p><strong>Vielen Dank f&uuml;r Ihre Bewerbung!</strong></p><p><br />Wir freuen uns, dass Sie Teil unseres Teams werden m&ouml;chten. Ihre Unterlagen werden nun von uns gepr&uuml;ft und wir melden uns zeitnah wieder bei Ihnen!</p><p><br />Viele Gr&uuml;&szlig;e<br />Ihr Recruiting-Team</p>',
              en_US: '<p><strong>Vielen Dank f&uuml;r Ihre Bewerbung!</strong></p><p><br />Wir freuen uns, dass Sie Teil unseres Teams werden m&ouml;chten. Ihre Unterlagen werden nun von uns gepr&uuml;ft und wir melden uns zeitnah wieder bei Ihnen!</p><p><br />Viele Gr&uuml;&szlig;e<br />Ihr Recruiting-Team</p>'
            }
            
        },
      
        //Avacon
        {
              companyIds: ["postingCompany_Avacon_GmbH~%1", "postingCompany_Avacon_AG~%1", "postingCompany_Avacon_GmbH", "postingCompany_Avacon_GmbH~%2", "postingCompany_HAzwei GmbH"],
              subheaderConfig: ["company", "contractType", "workTime", "locations"],
              ocaId: "avacon", //fuersMappingDerPrivacyTexte

              header: true,
              footer: false,
              disabilityText: {
                de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
                en_GB: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.',
                en_US: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.'
              },
              logo: "https://rmkcdn.successfactors.com/87ec45a4/a1b8ad4d-e1d8-48a9-ba5c-d.jpg",
              jobLayout: [
                {
                  id: "RecJobLayout_Avacon_00",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_01",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/9365c8ac-dc9c-474d-a142-d.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_02",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/832481de-4e30-4ad9-910a-c.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_03",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/aa3a6bb6-839a-494f-a6b3-b.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLaout_Avacon_04",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/1d4ef716-f26c-44bf-a1b5-e.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_05",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/94162e2c-c961-44f3-9a81-4.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_06",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/2d7aa0cd-b5ad-40b6-9c94-b.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_07",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/47d44f58-e89a-4628-88c6-2.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_08",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/84e6ffdd-ab91-4c03-9096-0.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_09",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/ae240de1-9c52-4100-a931-e.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_10",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/a305bd84-9d54-42dc-93b8-e.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_11",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/bdd64f9c-673c-46a4-99f5-7.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_12",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/d5f3ee12-29b8-433a-abec-7.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_13",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/b76f3354-7a73-449d-8103-9.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_14",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/e235c899-9388-4b15-be70-5.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_15",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/c667bccf-a6cc-48a9-928e-c.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_16",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/98f13f30-3d64-4d32-a2c2-6.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_17",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/a2a8fe47-460a-429b-8509-3.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_18",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/627acbdf-f7bc-4d3e-97bc-a.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_19",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/489495da-96c0-4775-a0f8-1.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_20",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/2d7aa0cd-b5ad-40b6-9c94-b.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_21",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/56710f9b-242b-4219-8d38-6.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_22",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/84e6ffdd-ab91-4c03-9096-0.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_23",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/daaf3f3a-a0bc-42d7-89ec-4.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_24",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/2159eb5c-cb3c-4472-95ce-3.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_25",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/b76f3354-7a73-449d-8103-9.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_26",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/b1d1c393-6641-4be2-9340-2.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_27",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/98f13f30-3d64-4d32-a2c2-6.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_28",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/7214061e-9871-4f79-b704-4.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_29",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/3a4b45bb-7c6e-4e96-956c-0.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_30",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/b882563d-8cb6-4440-a727-e.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_31",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/08485077-386c-4ea1-ac8b-a.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_32",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/427f4aa2-7501-4ae7-bb13-b.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_33",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/2c3d2d2c-ad0a-4320-bb2d-f.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_34",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/8050124e-5656-4049-b11d-8.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_35",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/5279fb5b-33bf-4e16-8994-5.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_36",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/6f3cf8fb-01e5-450f-ad12-f.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_37",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/86a6130a-509e-452c-8318-f.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_38",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/9d5970f0-6d17-4ab7-b4d4-9.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_39",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/6f1ce338-a2d7-46f5-9459-0.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_40",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/0d4871ae-6a94-419f-ad96-f.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_41",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/f9e6a725-0abf-4f81-becc-5.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_42",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/cdeb86e0-622d-4f1a-8e9d-5.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_43",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/401cee50-f019-48e0-960f-2.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_44",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/9d774ec8-63e9-450f-8c73-6.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_45",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/61e212d3-f96c-4bea-8e49-2.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_46",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/03290118-6811-48b5-9de0-c.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_47",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/3f929695-e035-4e64-9884-d.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_48",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/442c3046-19c6-4fcb-97dd-c.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Avacon_49",
                  pictureSize: 850,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/f03725eb-92a2-4cfa-b1b9-2.jpg"
                    }
                  ],
                }
              ],           
              

              links: {
                link1: {
                  de_DE: {
                    desc: "Karriere bei Avacon",
                    url: "https://www.avacon.de/de/karriere.html"
                  },
                  en_GB: {
                    desc: "Karriere bei Avacon",
                    url: "https://www.avacon.de/de/karriere.html"
                  },
                  en_US: {
                    desc: "Karriere bei Avacon",
                    url: "https://www.avacon.de/de/karriere.html"
                  }
                },
                link2: {
                  de_DE: {
                    desc: "Zurück zum Stellenmarkt",
                    url: "https://jobs.eon.com/avacon/go/Alle-Stellen-bei-Avacon/3728201/"
                  },
                  en_GB: {
                    desc: "Zurück zum Stellenmarkt",
                    url: "https://jobs.eon.com/avacon/go/Alle-Stellen-bei-Avacon/3728201/"
                  },
                  en_US: {
                    desc: "Zurück zum Stellenmarkt",
                    url: "https://jobs.eon.com/avacon/go/Alle-Stellen-bei-Avacon/3728201/"
                  }
                },
              },
              
              thankYouTexts: {
                de_DE: '<p><strong>Vielen Dank f&uuml;r deine Bewerbung.</strong></p><p><br />Wir freuen uns &uuml;ber dein Interesse an unserem Unternehmen und dass du unser Team mit deiner Energie unterst&uuml;tzen m&ouml;chtest.</p><p>Sobald die Bewerbungsfrist beendet ist, werden wir deine Unterlagen pr&uuml;fen und dir zeitnah eine R&uuml;ckmeldung geben. Den Status deiner Bewerbung kannst du jederzeit im Bewerberportal einsehen.</p><p>Solltest du dar&uuml;ber hinaus Fragen haben, wende dich bitte an den in der Stellenausschreibung genannten Kontakt.&nbsp;<br />Weitere Informationen zum Unternehmen, zum Recruiting-Prozess und rund um die Arbeit bei Avacon findest du auf unserer Karriereseite (LINK).&nbsp;</p><p>Zur&uuml;ck zum Stellenmarkt (LINK)</p>',
                en_GB: '<p><strong>Vielen Dank f&uuml;r deine Bewerbung.</strong></p><p><br />Wir freuen uns &uuml;ber dein Interesse an unserem Unternehmen und dass du unser Team mit deiner Energie unterst&uuml;tzen m&ouml;chtest.</p><p>Sobald die Bewerbungsfrist beendet ist, werden wir deine Unterlagen pr&uuml;fen und dir zeitnah eine R&uuml;ckmeldung geben. Den Status deiner Bewerbung kannst du jederzeit im Bewerberportal einsehen.</p><p>Solltest du dar&uuml;ber hinaus Fragen haben, wende dich bitte an den in der Stellenausschreibung genannten Kontakt.&nbsp;<br />Weitere Informationen zum Unternehmen, zum Recruiting-Prozess und rund um die Arbeit bei Avacon findest du auf unserer Karriereseite (LINK).&nbsp;</p><p>Zur&uuml;ck zum Stellenmarkt (LINK)</p>',
                en_US: '<p><strong>Vielen Dank f&uuml;r deine Bewerbung.</strong></p><p><br />Wir freuen uns &uuml;ber dein Interesse an unserem Unternehmen und dass du unser Team mit deiner Energie unterst&uuml;tzen m&ouml;chtest.</p><p>Sobald die Bewerbungsfrist beendet ist, werden wir deine Unterlagen pr&uuml;fen und dir zeitnah eine R&uuml;ckmeldung geben. Den Status deiner Bewerbung kannst du jederzeit im Bewerberportal einsehen.</p><p>Solltest du dar&uuml;ber hinaus Fragen haben, wende dich bitte an den in der Stellenausschreibung genannten Kontakt.&nbsp;<br />Weitere Informationen zum Unternehmen, zum Recruiting-Prozess und rund um die Arbeit bei Avacon findest du auf unserer Karriereseite (LINK).&nbsp;</p><p>Zur&uuml;ck zum Stellenmarkt (LINK)</p>'
              }
              
        },

        //EDN
        {
              companyIds: ["postingCompany_edialog_GmbH~%1"],
              subheaderConfig: ["company", "contractType", "workTime", "locations"],
              ocaId: "edn", //fuersMappingDerPrivacyTexte

              header: false,
              footer: true,
              disabilityText: {
                de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
                en_GB: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.',
                en_US: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.'
              },
              logo: "https://rmkcdn.successfactors.com/87ec45a4/54a7903d-d1cd-4bf2-bfa7-6.png",
              jobLayout: [





                {
                  id: "recJobLayout_Edialog-netz_00",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_01",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/aba769e9-3177-421c-ad9d-d.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_02",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/03541f11-dfc0-4d8f-8d6d-b.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_03",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/ffb3c1b5-48f8-4bc1-9c21-3.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_04",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/62d16c34-0fb5-4b7b-b1fc-c.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_05",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/352b4da3-1f0c-4347-b207-a.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_06",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/0619a895-5c1c-4ad4-88e6-0.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_07",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/38665689-3d73-4cf1-9bc2-3.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_08",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/87ec45a4/43cd5766-7114-4c0a-a69b-d.jpg"
                    }
                  ],
                },
                {
                  id: "recJobLayout_Edialog-netz_10",
                  pictureSize: 500,
                  pictures: [
                    {
                      src: "https://rmkcdn.successfactors.com/3c7383b9/c7a4ed99-02f9-4fcc-a401-2.jpg"
                    }
                  ],
                }
                
              ],           
            links: {
                link1: {
                  de_DE: {
                    desc: "Karriere bei der e.dialog Netz",
                    url: "https://www.edialog-netz.de/de/karriere.html"
                  },
                  en_GB: {
                    desc: "Karriere bei der e.dialog Netz",
                    url: "https://www.edialog-netz.de/de/karriere.html"
                  },
                  en_US: {
                    desc: "Karriere bei der e.dialog Netz",
                    url: "https://www.edialog-netz.de/de/karriere.html"
                  }
                },
                link2: {
                  de_DE: {
                    desc: "Über die e.dialog Netz",
                    url: "https://www.edialog-netz.de/de/ueber-uns.html"
                  },
                  en_GB: {
                    desc: "Über die e.dialog Netz",
                    url: "https://www.edialog-netz.de/de/ueber-uns.html"
                  },
                  en_US: {
                    desc: "Über die e.dialog Netz",
                    url: "https://www.edialog-netz.de/de/ueber-uns.html"
                  }
                },
                link3: {
                  de_DE: {
                    desc: "Stellenmarkt der e.dialog Netz",
                    url: "https://jobs.eon.com/edialog-netz/go/Alle-Stellen-bei-e_dialog-Netz/3728501/"
                  },
                  en_GB: {
                    desc: "Stellenmarkt der e.dialog Netz",
                    url: "https://jobs.eon.com/edialog-netz/go/Alle-Stellen-bei-e_dialog-Netz/3728501/"
                  },
                  en_US: {
                    desc: "Stellenmarkt der e.dialog Netz",
                    url: "https://jobs.eon.com/edialog-netz/go/Alle-Stellen-bei-e_dialog-Netz/3728501/"
                  }
                },
              },
            thankYouTexts: {
                de_DE: '<p><strong>Deine Unterlagen wurden uns erfolgreich &uuml;bermittelt. Vielen Dank!&nbsp;</strong></p><p>Wir nehmen uns nun Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.</p><p>Informiere Dich bis zu unserer R&uuml;ckmeldung gern &uuml;ber uns als attraktiven Arbeitgeber. Du findest uns bei kununu oder unter <a href="http://www.edialog.de">www.edialog.de</a>.</p>',
                en_GB: '<p><strong>Deine Unterlagen wurden uns erfolgreich &uuml;bermittelt. Vielen Dank!&nbsp;</strong></p><p>Wir nehmen uns nun Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.</p><p>Informiere Dich bis zu unserer R&uuml;ckmeldung gern &uuml;ber uns als attraktiven Arbeitgeber. Du findest uns bei kununu oder unter <a href="http://www.edialog.de">www.edialog.de</a>.</p>',
                en_US: '<p><strong>Deine Unterlagen wurden uns erfolgreich &uuml;bermittelt. Vielen Dank!&nbsp;</strong></p><p>Wir nehmen uns nun Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.</p><p>Informiere Dich bis zu unserer R&uuml;ckmeldung gern &uuml;ber uns als attraktiven Arbeitgeber. Du findest uns bei kununu oder unter <a href="http://www.edialog.de">www.edialog.de</a>.</p>'
              }
              
        },

        //EDIS
        {
            companyIds: ["postingCompany_EDIS_GmbH", "postingCompany_EDIS_AG~%1", "postingCompany_edistherm_GmbH", "postingCompany_edisnatur_GmbH", "postingCompany_ediscom_GmbH"],
            subheaderConfig: ["company", "contractType", "workTime", "locations"],
            ocaId: "edis", //fuersMappingDerPrivacyTexte

            header: true,
            footer: true,
            disabilityText: {
              de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
              en_GB: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.',
              en_US: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.'
            },
            logo: "https://rmkcdn.successfactors.com/87ec45a4/c74db9ff-447a-40b5-8aa0-4.jpg",
            jobLayout: [

              {
                id: "recJobLayout_E.DIS_00",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/3e696445-3803-40bf-9752-d.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_01",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/73a30c23-9039-4dde-a215-7.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_02",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/c27efe93-6f79-4a00-bf32-4.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_03",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/586c6366-664c-4eb2-981c-b.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_04",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/2a5f3b50-1938-45da-9906-c.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_05",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/2f7c4e82-5c93-4bc4-8dc0-7.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_06",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/2eb1c7b4-f81c-451c-bafb-6.png"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_07",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/cceb8f65-6b7a-477d-9fcb-3.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_08",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/fe7290ed-c398-49c7-aaf6-e.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_09",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/04180145-bea0-459d-8ef1-4.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_E.DIS_10",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/ecced478-a322-47de-ac0c-1.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_E.DIS_11",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/db39ea56-a34e-4bec-b94b-d.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_E.DIS_12",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/d5ae4a8a-b696-4f98-88e4-d.jpg"
                  }
                ]
              },
              {
                id: "recJobLayout_E.DIS_13",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/72605580-d724-4559-9742-a.jpg"
                  }
                ]
              }
            ],          
            
          links: {
              link1: {
                de_DE: {
                  desc: "Das ist die E.DIS AG (e-dis.de)",
                  url: "https://www.e-dis.de/de/ueber-uns/unternehmensportraet.html"
                },
                en_GB: {
                  desc: "Das ist die E.DIS AG (e-dis.de)",
                  url: "https://www.e-dis.de/de/ueber-uns/unternehmensportraet.html"
                },
                en_US: {
                  desc: "Das ist die E.DIS AG (e-dis.de)",
                  url: "https://www.e-dis.de/de/ueber-uns/unternehmensportraet.html"
                }
              },
              link2: {
                de_DE: {
                  desc: "Karriere (e-dis.de)",
                  url: "https://www.e-dis.de/de/karriere.html"
                },
                en_GB: {
                  desc: "Karriere (e-dis.de)",
                  url: "https://www.e-dis.de/de/karriere.html"
                },
                en_US: {
                  desc: "Karriere (e-dis.de)",
                  url: "https://www.e-dis.de/de/karriere.html"
                }
              },
            },
          thankYouTexts: {
              de_DE: '<p><strong>Deine Unterlagen wurden uns erfolgreich &uuml;bermittelt. Vielen Dank!&nbsp;</strong></p><p>Wir nehmen uns nun Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.</p><p>Informiere Dich bis zu unserer R&uuml;ckmeldung gern &uuml;ber uns als attraktiven Arbeitgeber. Du findest uns bei kununu oder unter <a href="http://www.edialog.de">www.edialog.de</a>.</p>',
              en_GB: '<p><strong>Deine Unterlagen wurden uns erfolgreich &uuml;bermittelt. Vielen Dank!&nbsp;</strong></p><p>Wir nehmen uns nun Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.</p><p>Informiere Dich bis zu unserer R&uuml;ckmeldung gern &uuml;ber uns als attraktiven Arbeitgeber. Du findest uns bei kununu oder unter <a href="http://www.edialog.de">www.edialog.de</a>.</p>',
              en_US: '<p><strong>Deine Unterlagen wurden uns erfolgreich &uuml;bermittelt. Vielen Dank!&nbsp;</strong></p><p>Wir nehmen uns nun Zeit Deine Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.</p><p>Informiere Dich bis zu unserer R&uuml;ckmeldung gern &uuml;ber uns als attraktiven Arbeitgeber. Du findest uns bei kununu oder unter <a href="http://www.edialog.de">www.edialog.de</a>.</p>'
            }
        },

        //RWW
        {
            companyIds: ["postingCompany_RWW mbH"],
            subheaderConfig: ["contractType", "workTime", "company", ],
            ocaId: "rww", //fuersMappingDerPrivacyTexte

            header: false,
            footer: false,
            disabilityText: {
              de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
              en_GB: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.',
              en_US: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.'
            },
            logo: "https://rmkcdn.successfactors.com/87ec45a4/23200083-2e6a-4775-a048-6.png",
            jobLayout: [
              {
                id: "recJobLayout_RWW_00",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/a5ad41c7-38dd-44fb-988e-8.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_RWW_01",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/d8706453-f32e-4a12-a144-4.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_RWW_02",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/bf7a5239-8346-452b-9835-5.jpg"
                  }
                ],
              },
              {
                id: "recLayout_RWW_03",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/24dddb0d-66f7-411a-aebc-d.jpg"
                  }
                ],
              },
              {
                id: "recLayout_RWW_04",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/c14a38d9-c7f4-4583-87ad-4.jpg"
                  }
                ],
              },
              {
                id: "recLayout_RWW_05",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/fc36208f-8519-40cf-9469-6.jpg"
                  }
                ],
              },
              {
                id: "recLayout_RWW_06",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/63998684-656e-42d0-b857-1.jpg"
                  }
                ],
              },
            ],          

          links: {
              link1: {
                de_DE: {
                  desc: "Karriere bei RWW",
                  url: "https://www.rww.de/unternehmen/karriere"
                },
                en_GB: {
                  desc: "Karriere bei RWW",
                  url: "https://www.rww.de/unternehmen/karriere"
                },
                en_US: {
                  desc: "Karriere bei RWW",
                  url: "https://www.rww.de/unternehmen/karriere"
                }
              },
              link2: {
                de_DE: {
                  desc: "Über RWW",
                  url: "https://www.rww.de/unternehmen"
                },
                en_GB: {
                  desc: "Über RWW",
                  url: "https://www.rww.de/unternehmen"
                },
                en_US: {
                  desc: "Über RWW",
                  url: "https://www.rww.de/unternehmen"
                }
              },
            },
          thankYouTexts: {
              de_DE: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung.&nbsp;</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt. Wir werden Ihre Bewerbungsunterlagen nun intensiv pr&uuml;fen, um uns einen Eindruck von Ihnen und Ihren Qualifikationen zu verschaffen. Wir setzen uns so schnell wie m&ouml;glich wieder mit Ihnen in Verbindung und bitten Sie bis dahin um ein wenig Geduld.</p>',
              en_GB: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung.&nbsp;</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt. Wir werden Ihre Bewerbungsunterlagen nun intensiv pr&uuml;fen, um uns einen Eindruck von Ihnen und Ihren Qualifikationen zu verschaffen. Wir setzen uns so schnell wie m&ouml;glich wieder mit Ihnen in Verbindung und bitten Sie bis dahin um ein wenig Geduld.</p>',
              en_US: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung.&nbsp;</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt. Wir werden Ihre Bewerbungsunterlagen nun intensiv pr&uuml;fen, um uns einen Eindruck von Ihnen und Ihren Qualifikationen zu verschaffen. Wir setzen uns so schnell wie m&ouml;glich wieder mit Ihnen in Verbindung und bitten Sie bis dahin um ein wenig Geduld.</p>'
            }
        },

        //EON RO
        {
                    companyIds: ["postingCompany_EON_SRL", "postingCompany_EON_Servicii", "postingCompany_EON_Clieni", "postingCompany_EON_Romnia~%1", "postingCompany_EON_Cluj", "postingCompany_Delgaz_Grid", "postingCompany_EON_Romnia"],
                    subheaderConfig: ["company", "locations" ],
                    ocaId: "eonRo", //fuersMappingDerPrivacyTexte

                    header: false,
                    footer: false,
                    disabilityText: { },
                    logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
                    jobLayout: [
                      {
                        id: "recJobLayout_Romania_00",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_01",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/c1a60115-76be-4fc7-b810-f.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_02",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/5d614645-d064-4797-8279-6.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_03",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/921094ec-e6bb-49bf-ba5d-9.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_04",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/a5eaede3-176b-455b-9234-f.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_05",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/8a54d281-f3de-4fef-8113-4.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_06",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/0625fe1d-6fb8-49e0-9631-8.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_07",
                        pictureSize: 500,
                        pictures: [
                          {
                            src: "https://rmkcdn.successfactors.com/87ec45a4/0c1a7e94-9d37-45aa-bd8d-6.jpg"
                          }
                        ],
                      },
                      {
                        id: "recJobLayout_Romania_08",
                        pictureSize: 500,
                        pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/1fd6a92a-b3e4-4aaf-baea-5.jpg"
                         }
                        ],
                      }
                    ],          

                  links: {
                      link1: {
                        en_GB: {
                          desc: "Career@E.ON",
                          url: "https://www.eon-romania.ro/ro/cariera.html"
                        },
                        en_US: {
                          desc: "Career@E.ON",
                          url: "https://www.eon-romania.ro/ro/cariera.html"
                        },
                        ro_RO: {
                          desc: "Cariere la E.ON",
                          url: "https://www.eon-romania.ro/ro/cariera.html"
                        }
                      },
                      link2: {
                        ro_RO: {
                          desc: "Despre noi",
                          url: "https://www.eon-romania.ro/ro/despre-noi.html"
                        },
                        en_GB: {
                          desc: "About Us",
                          url: "https://www.eon-romania.ro/ro/despre-noi.html"
                        },
                        en_US: {
                          desc: "About Us",
                          url: "https://www.eon-romania.ro/ro/despre-noi.html"
                        }
                      },
                    },
                  thankYouTexts: {
                      ro_RO: "<p>Îți mulțumim că ai facut primul pas către un job la E.ON. CV-ul tău este acum pe mâini bune!</p> <p>Apreciem efortul depus pentru a aplica la acest post. Ne vom uita cu atenție peste toate informațiile pe care ni le-ai transmis, de îndată ce anunțul va expira să vedem dacă ne potrivim.</p> <p>În timp ce noi analizăm informațiile transmise de tine, te încurajăm să afli mai multe despre E.ON și <a href=\"https://www.youtube.com/watch?v=5DG8Vt_Ql5Y\" target=\"_blank\">cultura noastră</a> organizațională. Vizitează și <a href=\"https://www.eon-romania.ro/ro.html\" target=\"_blank\">site-ul nostru oficial</a> oficial, unde poți să citești mai multe despre misiunea, tradiția și toate lucrurile interesante care se întâmplă În compania noastră.</p> <p>În cazul în care reiese din CV-ul tău că ne potrivim, noi te vom contacta să îți împărtășim următorii pași din procesul de recrutare. Adăugăm mereu noi oportunități pe <a href=\"https://jobs.eon.com/romania/go/Toate-joburile-din-Romania/3727401/?utm_source=pagina-cariere-ro\" target=\"_blank\">pagina noastră de cariere</a>, așa că te invităm să intri cât mai des să arunci o privire și de ce nu, să le spui și prietenilor tăi despre noi!</p> <p>Îți dorim energie cât cuprinde!<br />#eoncareer #WeHasNoLimits #BetterTogether</p>",
                      en_GB: "<p>We are happy that you want to become part of our team!</p><p>Thank you for taking the time to apply for this position. Your resume is now in good hands.</p><p>We will wait until the job ad for this position expires, so that all candidates who applied, can have equal chances.</p><p>The recruiter in charge of this position, will review all resumes, and if your skills are a match, we will contact you for the next step of the recruitment process.</p><p>If you want to be up to date with other opportunities in our company, check out our <a href=\"https://jobs.eon.com/romania/go/Toate-joburile-din-Romania/3727401/?utm_source=pagina-cariere-ro\" target=\"_blank\">Career Page</a>. Meanwhile, click <a href=\"https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D5DG8Vt_Ql5Y&amp;data=04%7C01%7Cioana-patricia.senes%40delgaz-grid.ro%7C114d3637eda346a7afc108d9c526f09e%7Cb914a242e718443ba47c6b4c649d8c0a%7C0%7C0%7C637757593292327304%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000&amp;sdata=i2ht3LVmVFsEaEcjm%2F%2BcoK%2F5WhyLKaZ47zdyStY3NSQ%3D&amp;reserved=0\" target=\"_blank\">here</a> so you get to know us better!</p><p>Keep up the good energy!</p><p>&nbsp;</p><p>#eoncareer #wehasnolimits #bettertogether</p>",
                      en_US: "<p>We are happy that you want to become part of our team!</p><p>Thank you for taking the time to apply for this position. Your resume is now in good hands.</p><p>We will wait until the job ad for this position expires, so that all candidates who applied, can have equal chances.</p><p>The recruiter in charge of this position, will review all resumes, and if your skills are a match, we will contact you for the next step of the recruitment process.</p><p>If you want to be up to date with other opportunities in our company, check out our <a href=\"https://jobs.eon.com/romania/go/Toate-joburile-din-Romania/3727401/?utm_source=pagina-cariere-ro\" target=\"_blank\">Career Page</a>. Meanwhile, click <a href=\"https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D5DG8Vt_Ql5Y&amp;data=04%7C01%7Cioana-patricia.senes%40delgaz-grid.ro%7C114d3637eda346a7afc108d9c526f09e%7Cb914a242e718443ba47c6b4c649d8c0a%7C0%7C0%7C637757593292327304%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000&amp;sdata=i2ht3LVmVFsEaEcjm%2F%2BcoK%2F5WhyLKaZ47zdyStY3NSQ%3D&amp;reserved=0\" target=\"_blank\">here</a> so you get to know us better!</p><p>Keep up the good energy!</p><p>&nbsp;</p><p>#eoncareer #wehasnolimits #bettertogether</p>"
                    }
              },
          
        //EON SWE
        {
            companyIds: ["postingCompany_EON_Sverige", "postingCompany_EON_AB~%14", "postingCompany_EON_AB~%13", "postingCompany_EON_AB~%8", "postingCompany_EON_AB~%10", "postingCompany_EON_Sverige_Navirum_Energi_AB"],
            subheaderConfig: ["locations", "contractType"],
            ocaId: "eonSwe", //fuersMappingDerPrivacyTexte

            header: false,
            footer: true,
            disabilityText: { },
            logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
            jobLayout: [
              {
                id: "recJobLayout_sverige_00",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_01",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/2c8393f1-e6b2-4767-b0dc-0.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_02",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/c544b4f6-f85f-4be1-a720-0.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_03",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/a6a50fdd-8f72-4e69-b2ac-6.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_04",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/4722d4e2-55d7-4dfa-be10-6.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_05",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/614f05e0-7178-4f2b-8a75-1.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_06",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/ef8bd131-6003-45bb-af2d-d.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_07",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/a70e1f3d-90ce-4963-a6c8-5.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_08",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/5cf9a01b-9ce5-4c21-aa8c-5.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_09",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/98b077b7-a8cb-4314-83ae-d.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_10",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/6d7e543f-38d9-44d6-95fc-2.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_11",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/faef769e-3a78-4e5d-abc5-1.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_sverige_12",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/fd347c02-72a4-494e-9555-2.jpg"
                  }
                ],
              },
            ],          
          links: {
              link1: {
                en_GB: {
                  desc: "About E.ON",
                  url: "https://www.eon.com/en/about-us.html?_gl=1*t2fvni*_ga*MjA3NTY1NDM5OC4xNjA4MDI5MDEy*_ga_NPWBKNR90T*MTY1MzAzNTc4NS4yMDUuMS4xNjUzMDM2MzQ1LjU1"
                },
                en_US: {
                  desc: "About E.ON",
                  url: "https://www.eon.com/en/about-us.html?_gl=1*t2fvni*_ga*MjA3NTY1NDM5OC4xNjA4MDI5MDEy*_ga_NPWBKNR90T*MTY1MzAzNTc4NS4yMDUuMS4xNjUzMDM2MzQ1LjU1"
                },
                sv_SE: {
                  desc: "Om E.ON",
                  url: "https://www.eon.se/om-e-on/om-foeretaget"
                }
              },
              link2: {
                en_US: {
                  desc: "Vacancies",
                  url: "https://jobs.eon.com/search/?createNewAlert=false&q=&optionsFacetsDD_country=SE&optionsFacetsDD_city=&optionsFacetsDD_customfield2=&locationsearch="
                },
                en_GB: {
                  desc: "Vacancies",
                  url: "https://jobs.eon.com/search/?createNewAlert=false&q=&optionsFacetsDD_country=SE&optionsFacetsDD_city=&optionsFacetsDD_customfield2=&locationsearch="
                },
                sv_SE: {
                  desc: "Jobbmöjligheter",
                  url: "https://jobs.eon.com/sverige/go/Alla-vakanser/3727801"
                }
              },
            },
          thankYouTexts: {
              sv_SE: "<h1 style=\"text-align: center;\">Tack för din ansökan!</h1> <p>Stort tack för att din ansökan, så roligt att du är intresserad av att arbeta med oss på E.ON!<br />Vi kommer att granska din ansökan och kontaktar dig så fort vi har ett besked till dig. Vi återkopplar till samtliga kandidater ifall de gått vidare till intervju eller inte.</p> <p>Mer information om vår rekryteringsprocess kan du hitta <a href=\"https://www.eon.se/om-e-on/jobb/rekryteringsprocessen\">här</a>.</p> <p>Vi vill tacka för ditt intresse och önskar dig en fortsatt trevlig dag!</p> <p>Vänliga hälsningar,<br />Rekryteringsteamet på E.ON</p>",
              en_GB: "<h1 style=\"text-align: center;\">Thank you for your application!</h1> <p>Thank you kindly for your application, we're happy to see that you're interested in working at E.ON! <br />We will review your application and will contact you as soon as we have a response to your. We reply to all candidates whether they proceed to an interview or not. <br /><br />More information about the recruitment process can be found <a href=\"https://www.eon.se/om-e-on/jobb/rekryteringsprocessen\">here</a>.</p> <p>We again want to thank you for your interest and wish you a great day!</p> <p>Best regards,<br />The Recruitment team at E.ON</p>",
              en_US: "<h1 style=\"text-align: center;\">Thank you for your application!</h1> <p>Thank you kindly for your application, we're happy to see that you're interested in working at E.ON! <br />We will review your application and will contact you as soon as we have a response to your. We reply to all candidates whether they proceed to an interview or not. <br /><br />More information about the recruitment process can be found <a href=\"https://www.eon.se/om-e-on/jobb/rekryteringsprocessen\">here</a>.</p> <p>We again want to thank you for your interest and wish you a great day!</p> <p>Best regards,<br />The Recruitment team at E.ON</p>"
            }
        },

        //EON CZ
        {
            companyIds: ["postingCompany_EON_as~%4", "postingCompany_EON_sro~%5", "postingCompany_EON_as~%5", "postingCompany_E.ON Energy Solutions s.r.o.","postingCompany_E.ON Ceská republika"],
            subheaderConfig: ["company", "locations"],
            ocaId: "eonCz", //fuersMappingDerPrivacyTexte

            header: true,
            footer: true,
            disabilityText: { 
              cs_CZ: 'Společnost E.ON se zavázala k rovným příležitostem a aktivně podporuje rozmanitost, rovnost a flexibilitu.',
              en_GB: 'E.ON is committed to equal opportunities and actively promotes diversity, equality and flexibility.',
              en_US: 'E.ON is committed to equal opportunities and actively promotes diversity, equality and flexibility.'
             },
            logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
            jobLayout: [
              {
                id: "recJobLayout_ceskarepublika_00",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/e38bb135-a130-492f-9b78-6.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_ceskarepublika_01",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/e7efb99e-858b-4612-9557-3.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_ceskarepublika_02",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/8a5e34a0-2b99-46ab-a95f-3.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_ceskarepublika_03",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/d681e0b9-932d-4397-84e1-b.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_ceskarepublika_04",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/c2474b3b-931b-484d-b775-5.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_ceskarepublika_05",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/cdb57e93-f64f-4194-9fc6-8.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_ceskarepublika_06",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/cf736a9b-c50c-4097-bf1d-8.jpg"
                  }
                ],
              },
              {
                id: "recJobLayout_ceskarepublika_07",
                pictureSize: 500,
                pictures: [
                  {
                    src: "https://rmkcdn.successfactors.com/87ec45a4/74d0c629-8ad9-47cb-80e0-9.jpg"
                  }
                ],
              },
            ],          
          links: {
              link1: {
                cs_CZ: {
                  desc: "Kariéra",
                  url: "https://www.eon.cz/kariera/"
                },
                en_US: {
                  desc: "Careers at E.ON Group",
                  url: "https://www.eon.cz/kariera/"
                },
                en_GB: {
                  desc: "Careers at E.ON Group",
                  url: "https://www.eon.cz/kariera/"
                }
              },
              link2: {
                cs_CZ: {
                  desc: "O nás",
                  url: "https://www.eon.cz/o-nas/"
                },
                en_GB: {
                  desc: "About Us",
                  url: "https://www.eon.cz/en/households/"
                },
                en_US: {
                  desc: "About Us",
                  url: "https://www.eon.cz/en/households/"
                }
              },
              link3: {
                cs_CZ: {
                  desc: "Linkedin",
                  url: "https://www.linkedin.com/company/e.on-cz/"
                },
                en_GB: {
                  desc: "Linkedin",
                  url: "https://www.linkedin.com/company/e.on-cz/"
                },
                en_US: {
                  desc: "Linkedin",
                  url: "https://www.linkedin.com/company/e.on-cz/"
                }
              },
              link4: {
                cs_CZ: {
                  desc: "Facebook",
                  url: "https://www.facebook.com/EON.CZ"
                },
                en_GB: {
                  desc: "Facebook",
                  url: "https://www.facebook.com/EON.CZ"
                },
                en_US: {
                  desc: "Facebook",
                  url: "https://www.facebook.com/EON.CZ"
                }
              },
            },
          thankYouTexts: {
              cs_CZ: "<p>Děkujeme za vyplněn&iacute;, va&scaron;e přihl&aacute;&scaron;ka je na cestě k n&aacute;m. Pros&iacute;m, dejte n&aacute;m chv&iacute;li času, abychom se pod&iacute;vali na va&scaron;e dokumenty a porovnali je s požadavky na danou pozici.&nbsp;</p><p>Do t&eacute; doby se zase vy můžete pod&iacute;vat, jak to u n&aacute;s ve společnosti žije. Nav&scaron;tivte n&aacute;&scaron; firemn&iacute; profil na <a href=\"https://www.linkedin.com/company/e.on-cz/\">LinkedIn</a> nebo n&aacute;s sledujte na Facebooku (<a href=\"https://www.facebook.com/EON.CZ\">E.ON CZ</a> a <a href=\"https://www.facebook.com/eonkariera\">E.ON Kari&eacute;ra</a>) a nezme&scaron;kejte tak ž&aacute;dn&eacute; na&scaron;e novinky.</p>",
              en_GB: "<p>Thank you for your interest in working with us. You have successfully applied for the position.<br />We will now take some time to review your documents and compare them with the requirements of the position.</p><p>In the meantime, visit our <a href=\"https://www.linkedin.com/company/e.on-cz/\">LinkedIn</a> company profile or follow us on Facebook (<a href=\"https://www.facebook.com/EON.CZ\">E.ON CZ</a> and <a href=\"https://www.facebook.com/eonkariera\">E.ON Careers</a>) so you don't miss any our news.</p>",
              en_US: "<p>Thank you for your interest in working with us. You have successfully applied for the position.<br />We will now take some time to review your documents and compare them with the requirements of the position.</p><p>In the meantime, visit our <a href=\"https://www.linkedin.com/company/e.on-cz/\">LinkedIn</a> company profile or follow us on Facebook (<a href=\"https://www.facebook.com/EON.CZ\">E.ON CZ</a> and <a href=\"https://www.facebook.com/eonkariera\">E.ON Careers</a>) so you don't miss any our news.</p>"
            }
        },

        //EON HUN
        {
          companyIds: ["postingCompany_EON_Kft~%4", "postingCompany_EON_Zrt~%3", "postingCompany_EON_Zrt~%2", "postingCompany_EON_Kft~%3", "postingCompany_EON_Kft~%7", "postingCompany_EON_Kft~%9", "postingCompany_EON_Zrt~%5", "postingCompany_EON_Zrt~%6", "postingCompany_EON_Kft~%2", "postingCompany_EON_Zrt~%4", "postingCompany_EON_Kft~%10", "postingCompany_EON_Kft~%15","postingCompany_E.ON MyEnergy Kft."],
          subheaderConfig: ["company","contractType","workTime"],
          ocaId: "eonHun", //fuersMappingOfThePrivacyText

          header: false,
          footer: false,
          disabilityText: { 
            hu_HU: 'A kiválasztási eljárás során az E.ON egyenlő esélyeket biztosít minden jelentkező számára nemzetiségre, korra, nemre, fogyatékosságra, illetve megváltozott munkaképességre való tekintet nélkül. A mi feladatunk az egyenlő esélyű részvétel technikai feltételeinek biztosítása. Kérjük, erre vonatkozó igényedet jelezd a pályázatodban. Akadályoz tartós egészségkárosodás, fogyatékosság a mindennapokban?',
            en_GB: 'E.ON is committed to being an inclusive employer. We recognise that everyone is different and we aim to provide a working environment where each person feels respected, valued and able to achieve their full potential. We are happy to consider flexible working arrangements. Please let us know via the application form if you require technical or organisational adjustments during the application process if there are any long-term conditions, disabilities or illnesses that limit your ability to work.',
            en_US: 'E.ON is committed to being an inclusive employer. We recognise that everyone is different and we aim to provide a working environment where each person feels respected, valued and able to achieve their full potential. We are happy to consider flexible working arrangements. Please let us know via the application form if you require technical or organisational adjustments during the application process if there are any long-term conditions, disabilities or illnesses that limit your ability to work.'
           },
          logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
          jobLayout: [
            {
              id: "recJobLayout_Magyarorszag_00",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/021173fd-2a86-4324-b2fe-8.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_01",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/1e74189a-6817-497c-9d08-f.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_02",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/fcef18e9-3e39-4fb4-a98f-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_03",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/f55695f8-4b1e-4e4e-bfb1-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_04",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/b77ebeb6-79f6-4cc6-91f6-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_05",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/2c8fc4d5-acb2-4505-95d7-d.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_06",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/cf683247-0318-42f5-9a6c-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_07",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/8255c52a-6e0c-40a0-9202-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_08",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/bbb40075-9d86-497d-bfb0-2.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Magyarorszag_09",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/bd78c821-7b08-4997-8271-1.jpg"
                }
              ],
            },
          ],          
        links: {
            link1: {
              hu_HU: {
                desc: "Rólunk",
                url: "https://www.eon.hu/hu/rolunk.html"
              },
              en_US: {
                desc: "About us",
                url: "https://www.eon.hu/hu/rolunk.html"
              },
              en_GB: {
                desc: "About us",
                url: "https://www.eon.hu/hu/rolunk.html"
              }
            },
            link2: {
              hu_HU: {
                desc: "Kiválasztási folyamat",
                url: "https://www.eon.hu/hu/rolunk/karrier/kivalasztasi-folyamat.html"
              },
              en_GB: {
                desc: "Recruitment process",
                url: "https://www.eon.hu/hu/rolunk/karrier/kivalasztasi-folyamat.html"
              },
              en_US: {
                desc: "Recruitment process",
                url: "https://www.eon.hu/hu/rolunk/karrier/kivalasztasi-folyamat.html"
              }
            },
            link3: {
              hu_HU: {
                desc: "Juttatások",
                url: "https://www.eon.hu/hu/rolunk/karrier/munkahelyunk-juttatasok.html"
              },
              en_GB: {
                desc: "Benefits",
                url: "https://www.eon.hu/hu/rolunk/karrier/munkahelyunk-juttatasok.html"
              },
              en_US: {
                desc: "Benefits",
                url: "https://www.eon.hu/hu/rolunk/karrier/munkahelyunk-juttatasok.html"
              }
            },
            link4: {
              hu_HU: {
                desc: "Az élet nálunk",
                url: "https://www.eon.hu/hu/rolunk/karrier/ertekeink.html"
              },
              en_GB: {
                desc: "Life at E.ON",
                url: "https://www.eon.hu/hu/rolunk/karrier/ertekeink.html"
              },
              en_US: {
                desc: "Life at E.ON",
                url: "https://www.eon.hu/hu/rolunk/karrier/ertekeink.html"
              }
            },
          },
        thankYouTexts: {
            hu_HU: "<h3><span style=\"color: #ff0000;\"><strong>K&ouml;sz&ouml;nj&uuml;k jelentkez&eacute;sedet!</strong></span></h3><p><span style=\"color: #000000;\">P&aacute;ly&aacute;zati anyagodat megkaptuk. &Aacute;ttekint&eacute;se ut&aacute;n &eacute;rtes&iacute;teni fogunk a kiv&aacute;laszt&aacute;si folyamatod tov&aacute;bbi l&eacute;p&eacute;seiről. Addig is k&ouml;sz&ouml;nj&uuml;k a t&uuml;relmedet.</span></p><p>V&aacute;llalatunkr&oacute;l, &eacute;rt&eacute;keinkről &eacute;s kiv&aacute;laszt&aacute;si folymatunkr&oacute;l bővebben a <a href=\"https://www.eon.hu/hu/rolunk/karrier.html\">karrieroldalunkon</a> olvashatsz vagy egyszerűen csak kattints a lenti linkekre.</p><p>&nbsp;</p><p>E.ON Toborz&aacute;s</p><p>&nbsp;</p>",
            en_GB: "<h3><span style=\"color: #ff0000;\">Thank you for your trust in us. </span></h3><p>Your application has been successfully submitted. We will review your application and get back to you as soon as possible.</p><p>In the meantime, why not keep your eye on other opportunities on our <a href=\"https://www.eon.hu/hu/rolunk/karrier.html\">careers website</a>.</p><p>E.ON Recruitment</p><p>&nbsp;</p>",
            en_US: "<h3><span style=\"color: #ff0000;\">Thank you for your trust in us. </span></h3><p>Your application has been successfully submitted. We will review your application and get back to you as soon as possible.</p><p>In the meantime, why not keep your eye on other opportunities on our <a href=\"https://www.eon.hu/hu/rolunk/karrier.html\">careers website</a>.</p><p>E.ON Recruitment</p><p>&nbsp;</p>",
          }
        },

        //E3
        {
          companyIds: ["postingCompany_E3_Haustechnik_GmbH"],
          subheaderConfig: ["company", "contractType", "workTime"],
          ocaId: "e3", //fuersMappingDerPrivacyTexte

          header: true,
          footer: true,
          disabilityText: { 
            de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern – sei es in Herkunft, Geschlecht, Alter, Lebens- und Arbeitsstilen, Talenten, Fähigkeiten und Einschränkungen.',
            en_GB: 'E.ON is committed to equal opportunities and actively promotes diversity, equality and flexibility.',
            en_US: 'E.ON is committed to equal opportunities and actively promotes diversity, equality and flexibility.'
           },
          logo: "https://rmkcdn.successfactors.com/87ec45a4/a4f5d273-5ba7-44b5-8183-4.png",
          jobLayout: [
            {
              id: "recJobLayout_E3_Bad_Umbau",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/f0698f85-c804-4dd8-a98d-1.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_E3_Heizung",
              pictureSize: 500,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/f1af06ab-3c79-4d46-b832-a.jpg"
                }
              ],
            },
          ],          
        links: {
            link1: {
              de_DE: {
                desc: "Weiter zur Website",
                url: "https://e3-haustechnik.de/"
              }
            },
          },
        thankYouTexts: {
            de_DE: "<p>Liebe Bewerberin, lieber Bewerber,</p><p>herzlichen Dank für Ihre Bewerbung - wir freuen uns auf die nächsten gemeinsamen Schritte.</p><p>Wir werden nun im Weiteren die Unterlagen genau prüfen und melden uns so schnell wie möglich zurück. In der Zwischenzeit finden Sie weitere Informationen auf <a href=\"https://www.e3-haustechnik.de\">www.e3-haustechnik.de</a> - wir freuen uns auf Ihren Besuch.</p><p>Mit freundlichen Grüßen</p><p><br />Ihr E3 Haustechnik-Recruitingteam</p><p>#innovativ #zuverlaessig #unserehaustechnik</p>"
          }
        },

        //Qualitas
        {
                companyIds: ["postingCompany_Qualitas-AMS_GmbH"],
                subheaderConfig: ["company", "contractType", "workTime"],
                ocaId: "qualitas", //fuersMappingDerPrivacyTexte

                header: true,
                footer: true,
                disabilityText: { 
                  de_DE: 'Die Integration von Menschen mit Behinderung entspricht unserem Selbstverständnis und wir begrüßen daher deren Bewerbung. Wir wären demzufolge dankbar zu erfahren, ob eine Schwerbehinderung gem. § 2 Abs.2 SGB IX vorliegt oder eine Gleichstellung gem. § 2 Abs.3 SGB IX festgestellt wurde. Wir weisen darauf hin, dass die Beantwortung dieser Frage freiwillig ist und im Falle einer bestehenden Schwerbehinderung/Gleichstellung nicht bzw. nicht wahrheitsgemäß beantwortet werden muss.',
                  en_GB: 'The integration of people with disabilities corresponds to our self-image and we welcome all applications. We would therefore be grateful to know whether a severe disability according to § 2 para. 2 SGB IX exists. We point out that answering this question is voluntary and does not have to be answered truthfully in the case of an existing severe disability.',
                  en_US: 'The integration of people with disabilities corresponds to our self-image and we welcome all applications. We would therefore be grateful to know whether a severe disability according to § 2 para. 2 SGB IX exists. We point out that answering this question is voluntary and does not have to be answered truthfully in the case of an existing severe disability.'
                 },
                logo: "https://rmkcdn.successfactors.com/3c7383b9/8545dda2-cfdd-43dc-acd2-4.jpg",
                jobLayout: [
                  {
                    id: "recJobLayout_Qualitas_Sicherungen_Kasten",
                    pictureSize: 500,
                    pictures: [
                      {
                        src: "https://rmkcdn.successfactors.com/3c7383b9/f0698f85-c804-4dd8-a98d-1.jpg"
                      }
                    ],
                  },
                  {
                    id: "recJobLayout_Qualitas_eMobilitaet_Auffahrt",
                    pictureSize: 500,
                    pictures: [
                      {
                        src: "https://rmkcdn.successfactors.com/3c7383b9/a5d75b0f-1785-4f31-a621-1.jpg"
                      }
                    ],
                  }
                ],          
              links: {
                  link1: {
                    de_DE: {
                      desc: "Weiter zur Website",
                      url: "https://www.qualitas-ams.de/"
                    }
                  },
                },
              thankYouTexts: {
                  de_DE: "<p>Liebe Bewerberin, lieber Bewerber,</p><p>herzlichen Dank für Ihre Bewerbung - wir freuen uns auf die nächsten gemeinsamen Schritte.</p><p>Wir werden nun im Weiteren die Unterlagen genau prüfen und melden uns so schnell wie möglich zurück. In der Zwischenzeit finden Sie weitere Informationen auf  <a href=\"https://www.qualitas-ams.de/\">www.qualitas-ams.de</a> - wir freuen uns auf Ihren Besuch.</p><p>Mit freundlichen Grüßen</p><p><br />Ihr Qualitas-AMS Recruitingteam</p><p>#innovativ #elektrisch #unserhandwerk</p>",
                }
        },
        //MINT:
        {
          companyIds: ["postingCompany_EONGesellschaften"],
          subheaderConfig: ["company", "locations"],
          ocaId: "eonStandard", //fuersMappingDerPrivacyTexte
          header: true,
          footer: true,
          disabilityText: {
            de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
            en_GB: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.',
            en_US: 'With our open and appreciative corporate culture, we welcome everyone. Because we are convinced that differences enrich us and therefore also welcome applications from people with disabilities. We would therefore be grateful to know whether you have been diagnosed with a severe disability. The answer is of course voluntary and does not have to be answered or not answered truthfully in this case.'
          },
           logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
           jobLayout: [
            {
              id: "recJobLayout_MINT_01",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/3c7383b9/759e7ba4-ebd4-4cd3-a6de-9.png"
                }
              ],
            },
          ],          
        links: {
          },
        thankYouTexts: {
            de_DE: "<p>Vielen Dank für deine Bewerbung.</p> <p>Wir freuen uns, dass du gemeinsam mit uns die Zukunft der Energiewende gestalten möchtest und melden uns zeitnah bei dir.</p> <p>Da unsere Kampagnenseite in regelmäßigen Abständen durch weitere Inhalte ergänzt wird, freuen wir uns, wenn du nochmal vorbeischaust und den Link mit interessierten Leuten aus deinem Umfeld teilst.</p>",
          }
        },
        //WESTCONNECT
        {
          companyIds: ["postingCompany_Westconnect GmbH"],
          ocaId: "westnetz", //fuersMappingDerPrivacyTexte
          subheaderConfig: ["company", "contractType", "workTime"],
          header: true,
          footer: true,
          disabilityText: {
            de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
            en_GB: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
            en_US: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.'
          },
          logo: require("../assets/westconnect.png"),
          jobLayout: [
            {
              id: "recJobLayout_Wir schaffen Verbindungen-Grün",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/e18691cb-2f67-47a8-b50c-3.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Wir schaffen Verbindungen-Blau",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/9244c228-e13c-401a-b574-b.jpg"
                }
              ],
            },
            {
              id: "recJobLayout_Wir schaffen Verbindungen-Violett",
              pictureSize: 850,
              pictures: [
                {
                  src: "https://rmkcdn.successfactors.com/87ec45a4/18d8723e-9d1d-45c3-9ffd-f.jpg"
                }
              ],
            },
          ],           
          links: {
            link1: {
              de_DE: {
                desc: "Karriere bei Westnetz",
                url: "https://www.westnetz.de/karriere"
              },
              en_GB: {
                desc: "Karriere bei Westnetz",
                url: "https://www.westnetz.de/karriere"
              },
              en_US: {
                desc: "Karriere bei Westnetz",
                url: "https://www.westnetz.de/karriere"
              }
            },
            link2: {
              de_DE: {
                desc: "Über Westnetz",
                url: "https://www.westnetz.de/de.html"
              },
              en_GB: {
                desc: "Über Westnetz",
                url: "https://www.westnetz.de/de.html"
              },
              en_US: {
                desc: "Über Westnetz",
                url: "https://www.westnetz.de/de.html"
              },
            },
          },
          thankYouTexts: {
            de_DE: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Ihre Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilden Sie sich in der Zwischenzeit gerne Ihre Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir &nbsp;empfehlen Ihnen einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren LinkedIn Unternehmensauftritt. Folgen Sie uns auch gerne &uuml;ber Facebook und verpassen Sie kein Update der Westnetz.</p>',
            en_GB: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Ihre Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilden Sie sich in der Zwischenzeit gerne Ihre Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir &nbsp;empfehlen Ihnen einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren LinkedIn Unternehmensauftritt. Folgen Sie uns auch gerne &uuml;ber Facebook und verpassen Sie kein Update der Westnetz.</p>',
            en_US: '<p><strong>Herzlichen Dank f&uuml;r Ihre Bewerbung</strong></p><p><br />Ihre Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Ihre Bewerbungsunterlagen zu Sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilden Sie sich in der Zwischenzeit gerne Ihre Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir &nbsp;empfehlen Ihnen einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren LinkedIn Unternehmensauftritt. Folgen Sie uns auch gerne &uuml;ber Facebook und verpassen Sie kein Update der Westnetz.</p>'
          }
        },

              //E.ON Grid Solutions GmbH
                {
                  companyIds: ["postingCompany_E.ON Grid Solutions GmbH"],
                  ocaId: "eonStandard", //fuersMappingDerPrivacyTexte
                  subheaderConfig: ["company", "contractType", "workTime", "locations"],
                  header: true,
                  footer: true,
                  disabilityText: {
                    de_DE: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
                    en_GB: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.',
                    en_US: 'Mit unserer offenen und wertschätzenden Unternehmenskultur heißen wir alle Menschen willkommen. Denn wir sind davon überzeugt, dass uns Unterschiede bereichern und begrüßen daher auch die Bewerbung von Menschen mit Behinderung. Wir wären Dir demzufolge dankbar, wenn Du uns angeben würdest, ob die Feststellung einer Schwerbehinderung oder einer Gleichstellung bei Dir vorliegt. Die Beantwortung ist selbstverständlich freiwillig und muss in dem Fall nicht bzw. nicht wahrheitsgemäß beantwortet werden.'
                  },
                  logo: "https://rmkcdn.successfactors.com/87ec45a4/4b1474d6-56b9-41f4-834f-5.png",
                  jobLayout: [
                    {
                      id: "recJobLayout_01_Grid_Classic red",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/c762f21a-506c-4bd5-bb96-2.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_02_Grid_Happy Woman",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/63130ed1-cf67-4001-9eb0-f.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_03_Grid_Team",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/0476af7e-a068-4c66-a5c0-8.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_04_Grid_Happy Man",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/da1252d3-ebab-400d-9f94-4.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_05_Grid_Woman bicycle",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/402442f8-d64a-4921-b9ff-3.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_06_Grid_Blanco E.ON Logo",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/50435e0d-43bd-4695-8c34-2.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_07_Grid_Hoerschutz",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/d6f19bdf-f789-4cef-b67b-e.jpg"
                        }
                      ],
                    },
                    {
                      id: "recJobLayout_08_Grid_woman clapping hands",
                      pictureSize: 500,
                      pictures: [
                        {
                          src: "https://rmkcdn.successfactors.com/87ec45a4/c2e6375c-69a4-417f-9d1e-3.jpg"
                        }
                      ],
                    },
                  ],           
                  links: {
                    link1: {
                      de_DE: {
                        desc: "Karriere bei E.ON Grid Solutions",
                        url: "https://jobs.eon.com/EONGrid/search/?createNewAlert=false&q=&optionsFacetsDD_country=&optionsFacetsDD_city=&optionsFacetsDD_customfield2=&locationsearch="
                      },
                      en_GB: {
                        desc: "Karriere bei E.ON Grid Solutions",
                        url: "https://jobs.eon.com/EONGrid/search/?createNewAlert=false&q=&optionsFacetsDD_country=&optionsFacetsDD_city=&optionsFacetsDD_customfield2=&locationsearch="
                      },
                      en_US: {
                        desc: "Karriere bei E.ON Grid Solutions",
                        url: "https://jobs.eon.com/EONGrid/search/?createNewAlert=false&q=&optionsFacetsDD_country=&optionsFacetsDD_city=&optionsFacetsDD_customfield2=&locationsearch="
                      }
                    },
                    link2: {
                      de_DE: {
                        desc: "Über E.ON Grid Solutions",
                        url: "https://www.eon-gridsolutions.com/de.html"
                      },
                      en_GB: {
                        desc: "Über E.ON Grid Solutions",
                        url: "https://www.eon-gridsolutions.com/de.html"
                      },
                      en_US: {
                        desc: "Über E.ON Grid Solutions",
                        url: "https://www.eon-gridsolutions.com/de.html"
                      },
                    }
                  },
                  thankYouTexts: {
                    de_DE: '<p><strong>Herzlichen Dank f&uuml;r Deine Bewerbung</strong></p><p><br />Deine Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Deine Bewerbungsunterlagen zu sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilde Dir in der Zwischenzeit gerne Deine Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir empfehlen Dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren Unternehmensauftritten bei LinkedIn, Xing und Instagram.&nbsp;</p>',
                    en_GB: '<p><strong>Herzlichen Dank f&uuml;r Deine Bewerbung</strong></p><p><br />Deine Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Deine Bewerbungsunterlagen zu sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilde Dir in der Zwischenzeit gerne Deine Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir empfehlen Dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren Unternehmensauftritten bei LinkedIn, Xing und Instagram.&nbsp;</p>',
                    en_US: '<p><strong>Herzlichen Dank f&uuml;r Deine Bewerbung</strong></p><p><br />Deine Unterlagen wurden erfolgreich &uuml;bermittelt.</p><p>Wir treffen unsere Entscheidungen nicht aus dem Bauch heraus, sondern nehmen uns die Zeit Deine Bewerbungsunterlagen zu sichten und mit dem Anforderungsprofil der Stelle abzugleichen.&nbsp;</p><p>Bilde Dir in der Zwischenzeit gerne Deine Meinung &uuml;ber uns als attraktiven Arbeitgeber. Wir empfehlen Dir einen Blick auf unsere Weiterempfehlungen auf kununu zu werfen oder unseren Unternehmensauftritten bei LinkedIn, Xing und Instagram.&nbsp;</p>'
                  }
                },
              ]

      // --- FUNCs ---

      let returnEntry = {}

      data.map(entry => {
        //Only if the entry contains the insertedCompanyId it shall return

        if (entry.companyIds.includes(insertedCompanyId)) {
          returnEntry = entry
        }
      })

      // Load defaults if companyId couldn't resolve
      //TODO: ISN'T WORKING
      if(returnEntry == undefined || returnEntry == "") {
        returnEntry = data[0]
      }

    return returnEntry
}

